<template>
	<div id="results">
		<div class="d-flex">
			<StatusBar :results="results"/>
			<Info :fileDetails="fileDetails"/>
		</div>
		<Box :results="results"/>	
	</div>
</template>

<script>
	import Info from '@/components/Actions/Results/Info.vue'
	import StatusBar from '@/components/Actions/Results/StatusBar.vue'
	import Box from '@/components/Actions/Results/Box.vue'

	export default {    
		name: 'Results',
		props: [
			'fileDetails',
			'results'
		],
		data() {
			return {
			}
		},
		components: { 
			Info,
			StatusBar,
			Box
		},
	}
</script>






